import {ErrorBox} from '@/components/commons/error-box/ErrorBox'
import {Container} from '@/components/ui/container/Container'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {FallbackProps} from 'react-error-boundary'

export const MissingDataErrorBoundary = ({props}: {props: FallbackProps}) => {
    return (
        <Container fullHeight>
            <ErrorBox icon={<AlertCircleIcon />} title={props.error.message} />
        </Container>
    )
}
